import OctorateBookingEngine from "@/components/OctorateBookingEngine";

export default function Booking() {
  return (
    <section id="booking" className="py-24 md:py-32 bg-brand-ivory/40">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.35em] uppercase text-brand-gold mb-4">Prenota</p>
          <h2 className="font-heading font-light text-4xl md:text-5xl text-brand-black">Prenota il tuo soggiorno</h2>
          <p className="mt-4 text-brand-brown text-lg">Tariffe e disponibilità sono aggiornate in tempo reale tramite il nostro sistema di prenotazione.</p>
        </div>
        <div className="mt-10">
          <OctorateBookingEngine />
        </div>
      </div>
    </section>
  );
}
